import { ReorderableList } from 'components/reorderable-list/reorderable-list';
import styles from './geometry-priority.module.scss';

interface GeometryPriorityProps {
  /** Ordered array of geometry type names */
  items: string[];
  /** Called when the user reorders items */
  onChange: (items: string[]) => void;
  /** Section label. Default: "Geometry Priority" */
  label?: string;
  /** Description text below label. Default: "When an area intersects..." */
  description?: string;
}

/**
 * Drag-to-reorder geometry priority list for scenario forms.
 * Wraps the shared ReorderableList with a label and description.
 * @param {GeometryPriorityProps} props - The component props
 * @return {JSX.Element} The geometry priority section
 */
export function GeometryPriority({
  items,
  onChange,
  label = 'Geometry Priority',
  description = 'When an area intersects multiple geometry types, the higher-ranked type takes precedence.',
}: GeometryPriorityProps): JSX.Element {
  return (
    <div className={styles.geometryPriority}>
      <h5 className={styles.label}>{label}</h5>
      <p className={styles.description}>{description}</p>
      <ReorderableList items={items} onReorder={onChange} />
    </div>
  );
}
